/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';
import Moment from 'react-moment';

import styles from './AuditAssetStatus.module.scss';

@translate()
export default class AuditAssetStatus extends React.Component<*> {
  render(): React.Element<*> {
    const asset: string = this.props.asset;
    const t: Function = this.props.t;

    return (
      <div className={styles['audit-status']}>
        <h3>{this.props.title || t('general:audit')}</h3>
        {asset.audit_date ? (
          <React.Fragment>
            <svg className={styles.approvedIcon}>
              <use xlinkHref="#icon-approve" />
            </svg>
            <Moment date={asset.audit_date} format="MMMM DD, YYYY" />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <svg className={styles.disabledIcon}>
              <use xlinkHref="#icon-declined" />
            </svg>
            {t('general:status.unknown')}
          </React.Fragment>
        )}
      </div>
    );
  }
}
